function drawFit(ctx, v, x, y, w, h) {
  if (!v || !v.videoWidth) return;
  const r = Math.min(w / v.videoWidth, h / v.videoHeight);
  const dw = v.videoWidth * r, dh = v.videoHeight * r;
  ctx.drawImage(v, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
}

// Registra in 360p: cliente a pieno schermo, operatore in riquadro, data/ora impressa. Una parte ogni 10 secondi.
export function createRecorder({ remoteVideo, localVideo, remoteStream, localStream, onChunk, startSeq = 0 }) {
  const canvas = document.createElement("canvas");
  canvas.width = 640; canvas.height = 360;
  const ctx = canvas.getContext("2d");
  const draw = () => {
    ctx.fillStyle = "#000"; ctx.fillRect(0, 0, 640, 360);
    drawFit(ctx, remoteVideo, 0, 0, 640, 360);
    ctx.fillStyle = "#111"; ctx.fillRect(476, 254, 160, 102);
    drawFit(ctx, localVideo, 476, 254, 160, 102);
    ctx.fillStyle = "rgba(0,0,0,.55)"; ctx.fillRect(0, 0, 640, 20);
    ctx.fillStyle = "#fff"; ctx.font = "12px sans-serif";
    ctx.fillText(`● REC  ${new Date().toLocaleString("it-IT")}`, 8, 14);
  };
  const iv = setInterval(draw, 1000 / 15);
  const ac = new AudioContext();
  const dest = ac.createMediaStreamDestination();
  [remoteStream, localStream].forEach((s) => { if (s && s.getAudioTracks().length) ac.createMediaStreamSource(s).connect(dest); });
  const out = new MediaStream([...canvas.captureStream(15).getVideoTracks(), ...dest.stream.getAudioTracks()]);
  const mimeType = ["video/webm;codecs=vp8,opus", "video/webm"].find((m) => window.MediaRecorder?.isTypeSupported(m));
  const mr = new MediaRecorder(out, { mimeType, videoBitsPerSecond: 450000, audioBitsPerSecond: 48000 });
  let seq = startSeq;
  mr.ondataavailable = (e) => { if (e.data && e.data.size) onChunk(seq++, e.data); };
  mr.start(10000);
  return {
    stop: () => new Promise((res) => {
      mr.onstop = () => { clearInterval(iv); ac.close(); res(); };
      if (mr.state !== "inactive") mr.stop(); else mr.onstop();
    }),
  };
}

export function grabFrame(video) {
  const c = document.createElement("canvas");
  c.width = video.videoWidth; c.height = video.videoHeight;
  c.getContext("2d").drawImage(video, 0, 0);
  return new Promise((res) => c.toBlob(res, "image/jpeg", 0.9));
}
